import * as React from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import BigCalendar from 'react-big-calendar';

// singletony
let dragContext: Function;
let dragDrop: Function;
let DragDropCalendar: any;

export default function withDragDropContext<P>(
    Component: React.ComponentClass<P> | React.StatelessComponent<P>): React.ComponentClass<P> {

    if (!dragContext) {
        dragContext = DragDropContext<P>(HTML5Backend);
    }

    return dragContext(Component);
}

export function withDragDrop(Component: any) {
    if (!dragDrop) {
        dragDrop = require('react-big-calendar/lib/addons/dragAndDrop');
    }

    return dragDrop(Component);
}

export function getDragCalendar() {
    if (!DragDropCalendar) {
        DragDropCalendar = withDragDrop(BigCalendar);
    }

    return DragDropCalendar;
}


// WEBPACK FOOTER //
// ./src/utils/withDragDropContext.ts